import React from "react";
import { BrowserRouter } from "react-router-dom";

import "url-search-params-polyfill";

import { Root } from "./root";

declare const __BASEPATH__: string, __DEV__: boolean;

const Application: React.SFC = () => (
  <BrowserRouter basename={__BASEPATH__}>
    <Root />
  </BrowserRouter>
);

const Component = __DEV__
  ? require("react-hot-loader").hot(module)(Application)
  : Application;

export default Component;
